<!-- Country Select -->
<p-select
  [options]="countries"
  [(ngModel)]="value"
  [showClear]="showClear"
  optionLabel="explicitTitle"
  optionValue="value"
  [placeholder]="placeholder | translate"
  [disabled]="disabled || loading"
  [styleClass]="styleClass"
  (onChange)="handleValueChange($event)"
  [filter]="true"
  [filterMatchMode]="'contains'"
  appendTo="body"
>
  <ng-template
    pTemplate="item"
    let-country
  >
    <div class="flex items-center py-2">
      @if (country.icon) {
        <img
          [src]="country.icon"
          [alt]="country.explicitTitle"
          class="mr-2 h-5 w-5"
        />
      }
      <span>{{ country.explicitTitle }}</span>
    </div>
  </ng-template>
  <ng-template
    pTemplate="value"
    let-country
  >
    @if (country) {
      <div class="flex items-center">
        @if (country.icon) {
          <img
            [src]="country.icon"
            [alt]="country.explicitTitle"
            class="mr-2 h-5 w-5"
          />
        }
        <span>{{ country.explicitTitle }}</span>
      </div>
    }
  </ng-template>
</p-select>
